import React from "react";
import Logo from "APP_ASSETS/images/info-trader-square-gray.png";

export default () => (
  <div style={{ position: "fixed", bottom: 10, right: 10 }}>
    <a href="https://infotrader.aero" target="_blank" rel="noopener noreferrer">
      <img
        src={Logo}
        height={50}
        width={50}
        style={{ cursor: "pointer" }}
        alt="Info Trader"
      />
    </a>
  </div>
);



// WEBPACK FOOTER //
// ./app/InfoLogo.jsx